<template>
  <b-card>
    <b-card-title>
      <b-row>
        <b-col>ภาพกิจกรรม</b-col>
        <b-col v-if="galleries.length" align="end">
          <b-button variant="success" class="text-white" @click="downloadAllPhotos()">
            <font-awesome-icon v-if="!isLoading" icon="file-archive" />
            <b-spinner v-else class="mr-1" small />
            ดาวน์โหลดรูปภาพทั้งหมด
          </b-button>
        </b-col>
      </b-row>
    </b-card-title>
    <div v-if="galleries.length === 0" class="b-row">
      <div class="b-col text-center text-secondary py-5">
        <font-awesome-icon :icon="['fa', 'images']" size="6x" />
        <h4 class="py-4">ไม่มีรูปภาพ</h4>
      </div>
    </div>
    <b-card-group columns>
      <b-card v-for="(gallery, index) in galleries" :key="index" :img-src="gallery.image"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
      >
        <b-card-text>
          <strong>คำอธิบายรูปภาพ</strong>
          <p :class="gallery.caption ? '' : 'text-muted font-italic'">{{ gallery.caption ? gallery.caption : '-- ไม่มีข้อมูล --' }}</p>
          <b-button v-if="$auth.check(ROLE_COORDINATOR)" size="sm" variant="danger" @click="deleteGallery(index)"><font-awesome-icon :icon="['fa', 'trash-alt']" />ลบรูปนี้</b-button>
        </b-card-text>
      </b-card>
    </b-card-group>
  </b-card>
</template>

<script>
import gql from 'graphql-tag'
import { ROLE_COORDINATOR } from '../../../../constants'

export default {
  props: {
    galleries: { type: Array, required: true }
  },
  data () {
    return {
      mainProps: { width: 200 },
      ROLE_COORDINATOR,
      isLoading: false
    }
  },
  methods: {
    async deleteGallery (index) {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $index: Int!) { projectGalleryDelete(id: $id, index: $index) { id } }`,
        variables: { id: this.$route.params.id, index: index }
      }).then(() => {
        this.$bvToast.toast('ลบรูปภาพสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true,
          noCloseButton: true
        })
      })
      this.$emit('finish')
    },
    async downloadAllPhotos () {
      this.isLoading = true
      const filePath = await this.$apollo.query({
        query: gql`query ($id: ID!) { projectDownloadAllPhotosZip(id: $id) { file } }`,
        variables: { id: this.$route.params.id },
        fetchPolicy: 'no-cache'
      })
      this.isLoading = false
      window.open(filePath.data.projectDownloadAllPhotosZip.file)
    }
  }
}
</script>

<style lang="scss" scoped>
td {

  &:first-child {
    background-color: #f2f2f2;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
th {

  &:first-child {
    background-color: #e7e7e7;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
